// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoaderButton_loader__6Pk8H","l23":"LoaderButton_l23__ztt8t","white":"LoaderButton_white__vQPNC","black":"LoaderButton_black__7IFmy"};